"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _emotionTheming = require("emotion-theming");

var _classnames = _interopRequireDefault(require("classnames"));

var _MultiSwitch = require("./MultiSwitch.style");

var MultiSwitch =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(MultiSwitch, _Component);

  function MultiSwitch() {
    (0, _classCallCheck2.default)(this, MultiSwitch);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(MultiSwitch).apply(this, arguments));
  }

  (0, _createClass2.default)(MultiSwitch, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setupSwitch(this.props);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.setupSwitch(this.props);
    }
  }, {
    key: "setupSwitch",
    value: function setupSwitch(props) {
      this.index = props.index + 1;
      var outerWidth = document.querySelector('.switchWrapper div:nth-child(' + this.index + ')').offsetWidth || 0;
      var leftSpace = document.querySelector('.switchWrapper div:nth-child(' + this.index + ')').offsetLeft;
      document.querySelector('.switchBgClass').style.width = outerWidth + 'px';

      if (this.index > 1) {
        document.querySelector('.switchBgClass').style.transform = 'translate3d(' + leftSpace + 'px, 0px, 0px)';
      } else {
        document.querySelector('.switchBgClass').style.transform = 'translate3d(0px, 0px, 0px)';
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          theme = _this$props.theme,
          wrapperClassName = _this$props.wrapperClassName,
          children = _this$props.children,
          _this$props$maxWidth = _this$props.maxWidth,
          maxWidth = _this$props$maxWidth === void 0 ? 'unset' : _this$props$maxWidth;
      return _react.default.createElement("div", {
        className: (0, _classnames.default)((0, _MultiSwitch.switchMainWrapper)(theme, maxWidth))
      }, _react.default.createElement("div", {
        className: (0, _classnames.default)((0, _MultiSwitch.switchWrapperStyles)(theme), wrapperClassName, 'switchWrapper')
      }, children), _react.default.createElement("div", {
        className: (0, _classnames.default)((0, _MultiSwitch.switchTransformWrapper)(theme), 'switchBgClass')
      }));
    }
  }]);
  return MultiSwitch;
}(_react.Component);

MultiSwitch.propTypes = {
  theme: _propTypes.default.object.isRequired,
  children: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node]).isRequired
};

var _default = (0, _emotionTheming.withTheme)(MultiSwitch);

exports.default = _default;